(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2737],{

/***/ 75374:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/mercari-seller-protection/index.tsx







function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2022-11-09",
      tag: "Mercari",
      title: "Protect your Mercari Business - Mercari`s Seller Protection",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "In this article, we focus on one of the essential considerations in choosing a platform: seller protection. Find out how Mercari protects its sellers and the best practices to observe to avert scammers and ensure you\u2019re covered in case of a dispute or when a damaged or lost item arises."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Be a compliant seller."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Mercari is home to a wide selection of items except illegal, dangerous, or stolen goods. The seller\u2019s responsibility is to make sure the item listed doesn\u2019t fall into Mercari\u2019s list of prohibited items. If uncertain about an item, it wouldn\u2019t hurt to inquire with customer service before listing and shipping it. Items classified as hazardous are not eligible for Shipping Protection, which guarantees as much as $200 for verified lost or damaged items shipped using a Mercari prepaid label."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "List items truthfully"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Prevent any possible miscommunication and return requests by including everything a buyer would want to know before purchasing an item. State the brand, size or measurements, color, condition, and other applicable information. For designer items, attach proof of authenticity. It\u2019s also crucial to disclose any flaws \u2013 even minimal ones\u2014 with photos for reference. When it comes to photos, Mercari encourages the use of clear ones taken by the sellers themselves instead of using lifted photos from the internet."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Exercise online safety"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Never entertain potential buyers requesting to conduct the transaction somewhere else, as Mercari won\u2019t be able to help you with anything that transpired outside of their App or website. Limit engagement only with users whose profile looks and feels legit and run by real people. Scams abound, so keep in mind to never share any personal contact information or other sensitive data like a bank account, credit card, or debit card details."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Ship items well and on time"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "A seller must send the item out within three days of purchase, regardless of the chosen carrier. Only shipments sent out with Mercari shipping label (USPS or FedEx), as well as those picked up and delivered by Mercari Now, are eligible for Shipping Protection which is at $200 max (the item\u2019s price excluding selling and processing fees) in case an item gets lost or damaged during transit."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Sellers who prefer to ship using their label must provide Mercari with a valid tracking number for proper shipment visibility and receipt confirmation. Otherwise, there won\u2019t be any kind of protection extended to the seller."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "It is always advisable to pack the item according to the carrier\u2019s packaging guidelines to avoid in-transit damages."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Be responsive and cooperative."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "When the item is delivered, the buyer receives a notification to confirm the delivery and rate the seller within three days. Suppose there is any problem with the item. In that case, the buyer must report any complaint or technical issue to Mercari customer support during this period, or else the sale will already be considered final (Mercari will leave a rating for the seller if the buyer doesn\u2019t leave any.) Payment is then released to the seller\u2019s account with an option to make ACH Direct Deposit or use Instant Pay."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Sellers must promptly respond when notified of any complaint or feedback and provide photographic evidence, receipts, and other necessary documents to help clarify and resolve the issue. Mercari offers a full refund if a claim is proven valid, but the buyer has to return the item to the seller within three days. If the seller receives a different item or an altered one \u2013 a typical modus operandi among online marketplace scammers \u2013 it should be promptly reported to Mercari."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "The customer service team handling such cases would most likely consider the users\u2019 transaction history and manner of communication. Hence, having an excellent seller reputation and maintaining professional behavior could make a difference."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Level up with OneShop"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Selling online involves a lot of risks. Thankfully, marketplaces like Mercari secure their sellers with the Seller Protection feature. With this, you don\u2019t need to worry about getting scammed or losing money over claims and disputes anymore."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Now that you are well-informed about what Mercari can offer to protect sellers like you, your next focus should be on how to boost your sales. While the key to boosting sales is to reach as many buyers as possible, this can be undeniably tiring and requires time and effort. But worry not, as OneShop can help you achieve your seller goals in no time with its helpful features such as relisting and cross-listing."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["OneShop can help you relist your listings with minimal effort and reach more buyers across other platforms with its cross-listing feature from Mercari to other marketplaces such as Poshmark, Depop, Tradesy, and soon, to eBay, Facebook Marketplace, and more. Free yourself from the tedious tasks of manually relisting and cross-listing to ensure higher visibility. With OneShop, you can now focus on other essential things that help you grow your reselling business and have more time on hand for your personal life.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Sign-up now and enjoy other OneShop features such as tracking your sales, setting your goals, and having an in-app seller community where you can share and interact with other sellers about relevant topics to online selling.", ' ']
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Make OneShop part of your business with the no-risk", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://tools.oneshop.com/signup",
          children: "7-day free trial"
        }), " and experience how this tool can make a difference to your reselling business."]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/mercari-seller-protection.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Protect your Mercari Business - Mercari`s Seller Protection"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Mercari is a selling platform for almost everything under the sun. It is ideal for sellers who have a myriad of different items to offer and wish to house them on one platform or those looking for another outlet to sell items under categories not hosted by other online marketplaces like Poshmark."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/mercari-seller-protection"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/mercari-seller-protection"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "Protect your Mercari Business - Mercari`s Seller Protection"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "Mercari is a selling platform for almost everything under the sun. It is ideal for sellers who have a myriad of different items to offer and wish to house them on one platform or those looking for another outlet to sell items under categories not hosted by other online marketplaces like Poshmark."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=3"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "2022-11-09T00:00:00-00:00"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "2022-11-09T00:00:00-00:00"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "Mercari"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 78265:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/mercari-seller-protection",
      function () {
        return __webpack_require__(75374);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(78265); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);